import './assets/style/tailwind.css';
import Antd from "ant-design-vue";
import 'ant-design-vue/dist/reset.css';
import { createApp } from 'vue'
import dayjs from 'dayjs'
import App from './App.vue'
import router from './router'
import store from './store'
let app = createApp(App);
app.config.globalProperties.$dateFormat = "DD/MM/YYYY";
app.config.globalProperties.$timeFormat = timeFormat;
app.config.globalProperties.$getHourMinute = getHourMinute;
app.config.globalProperties.$toTimeStamp = toTimeStamp;
app.use(store).use(Antd).use(router).mount('#app')



function timeFormat(t, hm, s) {
    if (!t) {
      return "";
    }
    if (typeof t != "number") {
      return t;
    }
    if (s) {
      t = t / 1000;
    }
    let d = new Date(t * 1000);
    let day = d.getDate();
    let m = d.getMonth() + 1;
    let y = d.getFullYear();
    if (day.toString().length == 1) {
      day = "0" + day.toString();
    }
    if (m.toString().length == 1) {
      m = "0" + m.toString();
    }
    let h = d.getHours();
    let mn = d.getMinutes();
    if (h.toString().length < 2) {
      h = "0" + h;
    }
    if (mn.toString().length < 2) {
      mn = "0" + mn;
    }
    if (hm) {
      return `${day}/${m}/${y} ${h}:${mn}`;
    }
    return `${day}.${m}.${y}`;
  }
  
  function getHourMinute(t, s) {
    if (typeof t != "number") {
      return t;
    }
    if (s) {
      t = t / 1000;
    }
    let d = new Date(t * 1000);
    let h = d.getHours();
    let mn = d.getMinutes();
    if (h.toString().length < 2) {
      h = "0" + h;
    }
    if (mn.toString().length < 2) {
      mn = "0" + mn;
    }
    return `${h}:${mn}`;
  }
  
  
  function toTimeStamp(time) {
    let e = time || 0;
    if (e) {
      return (dayjs(e).valueOf() / 1000).toFixed(0) * 1;
    } else {
      return e;
    }
  }
  